const getFileUploadResult = (result)=>{
    if (typeof result === 'string') {
        return result;
    }
    if (!result) {
        return null;
    }
    const key = ('errors' in result ? result.errors[0].code : result.message).toLowerCase();
    const keyToLabelMap = {
        'file-invalid-type': 'file not supported',
        'file-too-large': 'file too large',
        'too-many-files': 'too many files'
    };
    if (key.includes('recaptcha')) {
        return 'upload not possible - recaptcha';
    }
    return keyToLabelMap[key] || null;
};

export { getFileUploadResult };
//# sourceMappingURL=get-file-upload-result.js.map
